import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import HowBuyView from "../views/HowBuyView.vue";
import OrderView from "../views/OrderView.vue";
import Error404View from "../views/Error404View.vue";

Vue.use(VueRouter);

const routes = [
  {
    name: "Início",
    path: "/",
    component: HomeView,
  },
  {
    name: "Quem Somos",
    path: "/quem-somos",
    component: AboutView,
  },
  {
    name: "Como Comprar",
    path: "/como-comprar",
    component: HowBuyView,
  },
  {
    name: "Produto",
    path: "/p/:item",
    component: HomeView,
  },
  {
    name: "Pedido",
    path: "/o/:uuid",
    component: OrderView,
  },
  {
    path: "/erro404",
    name: "Erro 404",
    component: Error404View,
  },
  {
    path: "*",
    name: "Erro 404",
    component: Error404View,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
      // } else if (savedPosition || to.path.includes("/p/")) {
      //   return savedPosition;
    } else {
      return savedPosition;
    }
  },
  routes,
});

export default router;
